var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "middle-bar animated fadeInLeftBig" }, [
    _c(
      "div",
      { staticClass: "mainDiv" },
      [
        _c("div", { staticClass: "b-line" }),
        _vm._l(_vm.navList, function (item, i) {
          return _c(
            "div",
            { key: i },
            [
              _c("div", { staticClass: "flex" }, [
                _c("div", {
                  staticClass: "bf",
                  class: i === _vm.active ? "active" : "",
                }),
                _c(
                  "div",
                  {
                    staticClass: "item",
                    class: i === _vm.active ? "active" : "",
                    on: {
                      click: function ($event) {
                        return _vm.onChange(i)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(item.name) + " ")]
                ),
              ]),
              i === _vm.active
                ? _vm._l(item.children, function (it2, i2) {
                    return _c("div", { key: i2, staticClass: "flex sub" }, [
                      _c("div", {
                        staticClass: "bf",
                        class: it2.active === true ? "active" : "",
                      }),
                      _c(
                        "div",
                        {
                          staticClass: "item",
                          class: it2.active === true ? "active" : "",
                          on: {
                            click: function ($event) {
                              return _vm.onChange2(i2)
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(it2.name) + " ")]
                      ),
                    ])
                  })
                : _vm._e(),
            ],
            2
          )
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }